export default "__VITE_ASSET__CnqO_$kH__"